import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.PLAN_LIST_SUCCESS, data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.PLAN_LIST_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const planList = (params) => {
  return async (dispatch) => {
    dispatch({ type: CONST.PLAN_LIST_REQUEST });

    axios.get('/plans', { params }).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
